import React, { useContext, useState } from 'react'
import { LogoutIcon } from '@heroicons/react/outline'
import { useTranslation } from 'react-i18next'
import { UserContext } from '../../hooks/UserContext'
import { Notification } from '../../components'
import axiosInstance from '../../helpers/axiosInstance'
import { clearProcessed } from '../../utils/c2cReceiving'

export default function UserProfileSection({ isCollapsed, onExpand }) {
    const { t } = useTranslation()
    const context = useContext(UserContext)
    const user = context?.user || {}

    const [showLogoutError, setShowLogoutError] = useState(false)

    const initials = `${(user.first_name || '')[0] || ''}${(user.last_name || '')[0] || ''}`.toUpperCase()
    const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim()

    const handleLogout = async () => {
        try {
            await axiosInstance.post(
                `${process.env.REACT_APP_PLATFORM_URL}/api/v1/logout`,
                {},
                { withCredentials: true }
            )
            // Station PCs are shared: the Cubbitos strip holds recipient names and stays in
            // sessionStorage across a re-login in the same tab.
            clearProcessed()
            context.setUser({ isLogged: false })
            // A full document navigation, not history.push: station browsers stay open for
            // days, and a client-side route change keeps whatever JS bundle the tab started
            // with. index.html is served must-revalidate, so this is what picks up a deploy.
            // It matters here because the login screen is where the SSO identity check lives.
            window.location.assign('/login')
        } catch (e) {
            setShowLogoutError(true)
        }
    }

    if (isCollapsed) {
        return (
            <div className="py-3 flex justify-center border-t" style={{ borderColor: '#ebebeb' }}>
                <button
                    onClick={onExpand}
                    title={t('sidebar.expand_to_logout')}
                    className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-xs font-bold"
                    style={{ color: '#DCA118', borderColor: '#ebebeb' }}
                >
                    {initials}
                </button>
            </div>
        )
    }

    return (
        <>
            <Notification show={showLogoutError} setShow={setShowLogoutError} type="error" title={t('sidebar.logout_error')} />
            <button
                onClick={handleLogout}
                title={t('sidebar.sign_out')}
                aria-label={t('sidebar.sign_out')}
                className="w-full px-4 py-3 flex items-center gap-2.5 border-t hover:bg-gray-100 cursor-pointer text-left"
                style={{ borderColor: '#ebebeb' }}
            >
                <span
                    className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-xs font-bold flex-shrink-0"
                    style={{ color: '#DCA118' }}
                >
                    {initials}
                </span>
                <span className="flex-1 min-w-0">
                    <span className="block text-sm font-semibold text-gray-900 truncate">{fullName}</span>
                    <span className="block text-xs text-gray-400 truncate">{user.email}</span>
                </span>
                <LogoutIcon className="w-4 h-4 flex-shrink-0" style={{ color: '#DCA118' }} />
            </button>
        </>
    )
}
